
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchContactUsTable } from "../../api/contactUsApi";


export const getContactUs = createAsyncThunk(
    "roomType/getContactUs",
          //  @ts-ignore 
  
    async ({page,limit}, {dispatch, rejectWithValue }) => {
      dispatch(resetStatus());
  
      try {
        return await fetchContactUsTable(page,limit);
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );


  const contactUsSlice = createSlice({
    name: "contactUs",
    initialState: {
      contacts: [] as any[],
      status: null as boolean | null,
      msg: "",
      error: null as string | null,
    },
    reducers: {
      resetStatus(state) {
        state.status = null;
        state.msg = "";
      },
    },
    extraReducers: (builder) => {
      builder
        // Handle getRoomTypes
  
        .addCase(getContactUs.fulfilled, (state, action: PayloadAction<any[]>) => {
          state.status = true;
          state.contacts = action.payload;
        })
        .addCase(getContactUs.rejected, (state, action) => {
          state.status = false;
          state.error = action.payload as string;
        })
  
    },
  });
  
  export const { resetStatus } = contactUsSlice.actions;
  export default contactUsSlice.reducer;